import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbCollapse, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import {
    NgClickOutsideDelayOutsideDirective,
    NgClickOutsideDirective,
    NgClickOutsideExcludeDirective,
} from 'ng-click-outside2';
import { UIRouterModule } from '@uirouter/angular';
import { TranslateModule } from '../modules/translate.module';
import { UpgradePipeModule } from '@client/app/filters/upgrade-pipe.module';
import { MonEventModule } from '@monsido/services/mon-event/mon-event.module';
import { MonBrowserModule } from '@monsido/services/mon-browser/mon-browser.module';
import { DomainPanelComponent } from './menu/side-menu-search/domain-panel/domain-panel.component';
import { SideMenuSearchComponent } from './menu/side-menu-search/side-menu-search.component';
import { SearchInputComponent } from './menu/search-input/search-input.component';
import { TopMenuComponent } from './menu/top-menu.component';
import { SideMenuComponent } from './sidemenu/side-menu.component';
import { SideMenuAccessibilityComponent } from './sidemenu/menues/accessibility.component';
import { SideMenuAdminComponent } from './sidemenu/menues/admin.component';
import { SideMenuComplianceShieldComponent } from './sidemenu/menues/side-menu-compliance-shield.component';
import { SideMenuDataPrivacyComponent } from './sidemenu/menues/data-privacy.component';
import { SideMenuInventoryComponent } from './sidemenu/menues/side-menu-inventory.component';
import { SideMenuPagePerformanceComponent } from './sidemenu/menues/side-menu-page-performance.component';
import { SideMenuPolicyComponent } from './sidemenu/menues/side-menu-policy.component';
import { SideMenuQualityComponent } from './sidemenu/menues/quality.component';
import { SideMenuSeoComponent } from './sidemenu/menues/side-menu-seo.component';
import { SideMenuStatisticsComponent } from './sidemenu/menues/side-menu-statistics.component';
import { BaseLayoutComponent } from './base.component';
import { SubmenuDefaultComponent } from './submenu/menues/submenu-default.component';
import { SubmenuPolicyComponent } from './submenu/menues/submenu-policy.component';
import { IconsModule, MonEventTriggerModule } from '@monsido/angular-shared-components';
import { SpotlightModule } from '@client/app/modules/spotlight/spotlight.module';
import { ChatModule } from '@client/app/modules/chat/chat.module';
import { NotificationsModule } from '@client/app/modules/notifications/notifications.module';
import { MonAvatarComponent } from '@client/app/shared/mon-avatar/mon-avatar.component';
import { MonLegacyBrowserModule } from '@monsido/modules/legacy-browsers/legacy-browser.module';
import { FaviconWrapperComponent } from '@layout/favicon-wrapper/favicon-wrapper.component';
import { ComponentsModule } from '@client/app/components/components.module';
import {
    GlobalErrorMessageComponent,
} from '@client/app/shared-modules/global-error-message/global-error-message.component';
import { GlobalToastContainerComponent } from '@client/app/shared-modules/global-toast/components/global-toast-container/global-toast-container.component';
import { MessageService } from 'primeng/api';
import { OverlayWrapperModule } from '@client/app/modules/overlay-wrapper/overlay-wrapper.module';
import { NgbTooltipMfeModule } from '@client/mfe/overlay/ngb-tooltip-mfe.module';
import { TopNavigationComponent } from '@client/app/feature-modules/navigation/top-navigation.component';
import {
    SideNavigationContainerComponent,
} from '@client/app/feature-modules/navigation/components/side-navigation/side-navigation-container.component';

@NgModule({
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        CommonModule,
        FormsModule,
        NgbTooltipMfeModule,
        NgClickOutsideDirective,
        UIRouterModule,
        TranslateModule,
        UpgradePipeModule,
        MonEventModule,
        MonBrowserModule,
        MonEventTriggerModule,
        SpotlightModule,
        ChatModule,
        NotificationsModule,
        MonAvatarComponent,
        MonLegacyBrowserModule,
        FaviconWrapperComponent,
        NgClickOutsideExcludeDirective,
        NgbDropdownModule,
        IconsModule,
        NgClickOutsideDelayOutsideDirective,
        ComponentsModule,
        NgbCollapse,
        GlobalErrorMessageComponent,
        GlobalToastContainerComponent,
        OverlayWrapperModule,
        TopNavigationComponent,
        SideNavigationContainerComponent,
    ],
    declarations: [
        BaseLayoutComponent,
        DomainPanelComponent,
        SideMenuSearchComponent,
        SearchInputComponent,
        TopMenuComponent,
        SideMenuComponent,
        SideMenuAccessibilityComponent,
        SideMenuAdminComponent,
        SideMenuComplianceShieldComponent,
        SideMenuDataPrivacyComponent,
        SideMenuInventoryComponent,
        SideMenuPagePerformanceComponent,
        SideMenuPolicyComponent,
        SideMenuQualityComponent,
        SideMenuSeoComponent,
        SideMenuStatisticsComponent,
        SubmenuDefaultComponent,
        SubmenuPolicyComponent,
    ],
    exports: [
        BaseLayoutComponent,
        DomainPanelComponent,
        SideMenuSearchComponent,
        SearchInputComponent,
        TopMenuComponent,
        SideMenuComponent,
        SideMenuAccessibilityComponent,
        SideMenuAdminComponent,
        SideMenuComplianceShieldComponent,
        SideMenuDataPrivacyComponent,
        SideMenuInventoryComponent,
        SideMenuPagePerformanceComponent,
        SideMenuPolicyComponent,
        SideMenuQualityComponent,
        SideMenuSeoComponent,
        SideMenuStatisticsComponent,
        SubmenuDefaultComponent,
        SubmenuPolicyComponent,
    ],
    providers: [
        MessageService,
    ],
})
export class UpgradeLayoutModule {}
